import { createFileRoute, Link } from "@tanstack/react-router";
import { useGetInspection } from "@/api/client-inspection";
import { PageStatus } from "@/components/page-status";
import { Button } from "@/components/ui/button";
import {
  DetailCardSkeleton,
  DetailHeaderSkeleton,
} from "@/components/ui/detail-skeleton";
import { InspectionDetailsView } from "@/sections/inspections/view/inspection-details-view";

// Mirrors InspectionDetailsView: header bar + the two-column workspace
// (working surface on the left, status / key-details rail on the right).
function InspectionDetailsSkeleton() {
  return (
    <>
      <DetailHeaderSkeleton eyebrow subtitle trailingPills={2} />
      <div className="grid gap-5 p-6 lg:grid-cols-[minmax(0,1fr)_320px]">
        <div className="flex flex-col gap-4 min-w-0">
          <DetailCardSkeleton rows={4} />
          <DetailCardSkeleton rows={3} />
        </div>
        <div className="flex flex-col gap-4">
          <DetailCardSkeleton rows={3} />
          <DetailCardSkeleton rows={2} />
          <DetailCardSkeleton rows={5} />
        </div>
      </div>
    </>
  );
}

function InspectionDetailsPage() {
  const { inspectionId } = Route.useParams();
  const { data, isLoading } = useGetInspection(inspectionId);

  if (isLoading) {
    return <InspectionDetailsSkeleton />;
  }

  if (!data) {
    return (
      <PageStatus
        variant="not-found"
        title="Inspection not found"
        description="This inspection may have been removed, or the reference in the link is incorrect. Check the reference and try again from the inspections list."
        actions={
          <>
            <Button
              nativeButton={false}
              render={<Link to="/dashboard/inspections" />}
            >
              Back to inspections
            </Button>
            <Button
              variant="outline"
              nativeButton={false}
              render={<Link to="/dashboard" />}
            >
              Go to dashboard
            </Button>
          </>
        }
      />
    );
  }

  return <InspectionDetailsView inspection={data} />;
}

export const Route = createFileRoute("/dashboard/inspections/$inspectionId/")({
  component: InspectionDetailsPage,
  staticData: {
    title: "Inspection Details",
    parent: { title: "Inspections", path: "/dashboard/inspections" },
  },
});
